import { render, staticRenderFns } from "./codelogin.vue?vue&type=template&id=2e316e58&scoped=true&"
import script from "./codelogin.vue?vue&type=script&lang=js&"
export * from "./codelogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e316e58",
  null
  
)

export default component.exports